'use client'

import React, { ReactNode } from 'react'
import { Loading } from '@repo/ui/icons/loading'
import { twMerge } from 'tailwind-merge'
import { motion } from 'motion/react'
import { ArrowIcon } from '@/components/icons/arrow-icon'

interface ButtonProps {
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  loading?: boolean
  className?: string
  arrow?: boolean
  children?: ReactNode
}

const ButtonCustom: React.FC<ButtonProps> = ({
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  className,
  arrow = false,
  children,
}) => {
  const [isHover, setIsHover] = React.useState(false)

  return (
    <motion.button
      whileTap={disabled ? undefined : { scale: 0.9 }}
      onClick={onClick}
      type={type}
      disabled={disabled}
      onHoverStart={() => setIsHover(true)}
      onHoverEnd={() => setIsHover(false)}
      className={twMerge(
        'disabled:checkout-grey-500 flex max-w-fit flex-row items-center justify-center gap-2 rounded-md bg-red-primary px-8 py-2 text-base font-bold text-white hover:bg-red-secondary focus:outline-none',
        className
      )}>
      {children}
      {arrow && <ArrowIcon rotate={isHover} />}
      {loading && <Loading />}
    </motion.button>
  )
}

export default ButtonCustom
